import {isNotNilOrEmpty} from 'shared/web';

export const isCI = isNotNilOrEmpty(process.env.GITLAB_CI);
